module.exports = __webpack_public_path__ + "img/2.dd9b530d.png";